import { action$, ActionCreator, derivedStream, ofType } from '@ardoq/rxbeach';
import { tags$ } from 'streams/tags/tags$';
import { debounceTime, map, shareReplay } from 'rxjs/operators';
import { merge } from 'rxjs';
import { components$ } from 'streams/components/components$';
import { fields$ } from 'streams/fields/fields$';
import { notifyFiltersChanged } from 'streams/filters/FilterActions';
import { groupingRules$ } from 'streams/grouping/groupingRules$';
import { graphModel$ } from './graphModel$';
import { DEFAULT_DEBOUNCE_TIME } from './consts';
import { persistentWorkspaces$ as workspaces$ } from 'streams/workspaces/workspaces$';
import { models$ } from 'streams/models/models$';

export const nonComponentModelUpdateActions: ActionCreator<any>[] = [
  notifyFiltersChanged,
];

const modelUpdate$ = merge(
  action$.pipe(ofType(...nonComponentModelUpdateActions)),
  components$,
  models$,
  fields$,
  tags$,
  groupingRules$
).pipe(debounceTime(DEFAULT_DEBOUNCE_TIME));

const modelUpdateNotification$ = derivedStream(
  'modelUpdateNotification$',
  modelUpdate$,
  graphModel$,
  workspaces$
).pipe(
  map(() => null),
  shareReplay({ bufferSize: 1, refCount: true })
);

export { modelUpdateNotification$ };

export const modelUpdateNotificationWithoutGraph$ = merge(
  modelUpdate$,
  workspaces$
).pipe(
  map(() => null),
  shareReplay({ bufferSize: 1, refCount: true })
);
